
export class UserStatesModel {
  total: number;
}
